import { NavLink } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";

const navItems = [
  { to: "/", label: "Dashboard", end: true },
  { to: "/templates", label: "Templates", end: false },
  { to: "/configurations", label: "Konfigurationen", end: false },
  { to: "/jobs", label: "Jobs", end: false },
];

export function BottomNav() {
  const { isAuthenticated, principal, logout } = useAuth();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 py-3">
          <span className="text-sm font-semibold text-slate-800">
            Zauber.app
          </span>
          <div className="flex items-center gap-3">
            {principal ? (
              <span className="text-xs text-slate-500">
                {principal.display_name ?? principal.user_id}
              </span>
            ) : null}
            <button
              type="button"
              onClick={logout}
              className="inline-flex min-h-touch items-center rounded-md border border-slate-300 px-3 py-1 text-xs font-medium text-slate-600 hover:bg-slate-100 focus-visible:outline focus-visible:ring-2 focus-visible:ring-slate-500"
            >
              Abmelden
            </button>
          </div>
        </div>
      </header>

      <nav
        className="fixed bottom-0 left-0 right-0 z-10 border-t border-slate-200 bg-white md:hidden"
        aria-label="Hauptnavigation"
      >
        <ul className="mx-auto flex max-w-3xl items-stretch justify-around">
          {navItems.map((item) => (
            <li key={item.to} className="flex-1">
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex min-h-touch flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium ${
                    isActive
                      ? "text-slate-900"
                      : "text-slate-500 hover:text-slate-700"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={`h-1 w-6 rounded-full ${
                        isActive ? "bg-slate-900" : "bg-transparent"
                      }`}
                      aria-hidden="true"
                    />
                    <span>{item.label}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <nav
        className="hidden border-b border-slate-200 bg-white md:block"
        aria-label="Hauptnavigation"
      >
        <ul className="mx-auto flex max-w-3xl gap-1 px-4">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `inline-flex min-h-touch items-center px-4 py-3 text-sm font-medium ${
                    isActive
                      ? "border-b-2 border-slate-900 text-slate-900"
                      : "text-slate-500 hover:text-slate-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
